import { render, staticRenderFns } from "./tendersTileCharts.vue?vue&type=template&id=3bd74f6c&scoped=true&"
import script from "./tendersTileCharts.vue?vue&type=script&lang=js&"
export * from "./tendersTileCharts.vue?vue&type=script&lang=js&"
import style0 from "./tendersTileCharts.vue?vue&type=style&index=0&id=3bd74f6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd74f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd74f6c')) {
      api.createRecord('3bd74f6c', component.options)
    } else {
      api.reload('3bd74f6c', component.options)
    }
    module.hot.accept("./tendersTileCharts.vue?vue&type=template&id=3bd74f6c&scoped=true&", function () {
      api.rerender('3bd74f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/tendersTileCharts.vue"
export default component.exports